/* eslint-disable no-nested-ternary */
import React, {
  useEffect, useState, Fragment, useMemo,
} from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Tooltip, Select,
  Button,
  Drawer,
} from 'antd';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import AnalyticsActions from '@Actions/application/analyticsActions';
import H3DateSelector from '@Uilib/h3DateSelector';
import H3Text from '@Uilib/h3Text';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import CustomerActions from '@Actions/customerActions';
import MetricWithAmountSplit from '@Components/Home/HomeTabs/Widgets/MetricWithAmountSplit';
import TenantActions from '@Actions/tenantActions';
import SelectUser from '@Components/Common/SelectUser';
import { CloseOutlined } from '@ant-design/icons';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import SelectCustomer from '../../../Common/SelectCustomer';
import MetricView from '../Widgets/MetricView';
import MetricBarLineChart from '../Widgets/MetricBarLineChart';
import MetricSalesPieChart from './Widgets/MetricSalesPieChart';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';
import './style.scss';

const { Option } = Select;

/**
 *
 */
function SalesDashboard({
  user, history, getAnalyticsData, analytics, MONEY, orgUsers, getOrgUsers, getCustomers,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedInterval, setSelectedInterval] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [isUserReady, setIsUserReady] = useState(false);
  const [call, setCall] = useState(false);
  const [type, setType] = useState('CATEGORY');
  const [source, setSource] = useState([]);
  const [interval, setInterval] = useState('30');
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [filterChanged, setFilterChanged] = useState(false);
  const [firstTimeFilterDisable, setFirstTimeFilterDisable] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  const showDrawer = () => setIsDrawerVisible(true);
  const closeDrawer = () => setIsDrawerVisible(false);
  const [taxType, setTaxType] = useState('EXCLUSIVE_OF_TAX');

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  // Effect to monitor changes in filter fields
  useEffect(() => {
    if (firstTimeFilterDisable) {
      setFilterChanged(true);
    }
  }, [selectedTenant, selectedInterval, startDate, endDate, source, selectedCustomer, selectedAssignee, taxType]);

  // Function to handle Apply Filters button click
  const handleApplyFilters = () => {
    setCall(!call);
    setFirstTimeFilterDisable(true);
    setFilterChanged(false);
    closeDrawer();
  };

  const customerColumns = [
    {
      title: '',
      render: (record) => (
        <Link to={`/sales/customer/view/${record.customer_id}`}>
          <div className="mobile-list__item">
            <div style={{ display: 'flex' }}>
              <H3Text text={`${record?.customer_name}`} className="mobile-list__item-number" />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                marginBottom: '5px',
                marginTop: '5px',
              }}
            >
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <span style={{ color: '#888888' }}>Sales : </span>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_sales?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <span style={{ color: '#888888' }}>Discount : </span>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_discount?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <span style={{ color: '#888888' }}>COGS : </span>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_cogs?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
            </div>
            <H3Text
              text={(
                <span className="mobile-list__item-info">
                  <span style={{ color: '#888888' }}>Net Margin : </span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <H3Text className={`${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(record?.net_margin.toFixed(2)).split('.')[0]} />
                    <span className={`table-subscript ${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`}>
                      {record.net_margin_percentage ? `(${record.net_margin_percentage > 0 ? '+' : ''}${record.net_margin_percentage?.toFixed(2)}%)` : '-'}
                    </span>
                  </div>
                </span>
              )}
            />
            {' '}
          </div>
        </Link>
      ),
      responsive: ['xs'],
    },
    {
      title: 'Customer',
      render: (text, record) => (
        <Tooltip title={record?.customer_name} className="">
          <a target="_blank" href={`/sales/customer/view/${record?.customer_id}`} rel="noreferrer">
            <div>{record?.customer_name?.trim()?.length > 15 ? `${record?.customer_name.trim()?.substring(0, 15)}..` : record?.customer_name}</div>
          </a>
        </Tooltip>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Sales',
      render: (text, record) => <H3Text text={MONEY(record?.net_sales?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_sales - b.net_sales,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Discount',
      render: (text, record) => <H3Text text={MONEY(record?.net_discount?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_discount - b.net_discount,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'COGS',
      render: (text, record) => <H3Text text={MONEY(record?.net_cogs?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_cogs - b.net_cogs,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Net Margin',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <H3Text className={`${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(record?.net_margin.toFixed(2)).split('.')[0]} />
          <span className={`table-subscript ${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`}>
            {record.net_margin_percentage ? `${record.net_margin_percentage > 0 ? '+' : ''}${record.net_margin_percentage?.toFixed(2)}%` : '-'}
          </span>
        </div>
      ),
      sorter: (a, b) => a.net_margin_percentage - b.net_margin_percentage,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
  ];
  const productColumns = [
    {
      title: '',
      render: (record) => (
        <Link to={`/inventory/product/view/${record.product_sku_id}`}>
          <div className="mobile-list__item">
            <div style={{ display: 'flex' }}>
              <H3Text text={`${record?.internal_sku_code} - ${record?.product_sku_name}`} className="mobile-list__item-number" />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                marginBottom: '5px',
                marginTop: '5px',
              }}
            >
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>Units : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.total_units?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>Sales : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_sales?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>Discount : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_discount?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>COGS : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_cogs?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
            </div>
            <H3Text
              text={(
                <span className="mobile-list__item-info">
                  <span style={{ color: '#888888' }}>Net Margin : </span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <H3Text className={`${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(record?.net_margin.toFixed(2)).split('.')[0]} />
                    <span className={`table-subscript ${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`}>
                      {record.net_margin_percentage ? `(${record.net_margin_percentage > 0 ? '+' : ''}${record.net_margin_percentage?.toFixed(2)}%)` : '-'}
                    </span>
                  </div>
                </span>
              )}
            />
            {' '}
          </div>
        </Link>
      ),
      responsive: ['xs'],
    },
    {
      title: 'Product Name',
      render: (text, record) => (
        <Tooltip title={`${record?.internal_sku_code} - ${record?.product_sku_name}`} className="">
          <a target="_blank" href={`/inventory/product/view/${record.product_sku_id}`} rel="noreferrer">
            <div>{record?.product_sku_name?.trim()?.length > 10 ? `${record?.product_sku_name.trim()?.substring(0, 10)}..` : record?.product_sku_name}</div>
          </a>
        </Tooltip>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Units',
      render: (text, record) => <H3Text text={record?.total_units?.toFixed(2).split('.')[0]} className="" />,
      sorter: (a, b) => a.total_units - b.total_units,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Sales',
      render: (text, record) => <H3Text text={MONEY(record?.net_sales?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_sales - b.net_sales,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Discount',
      render: (text, record) => <H3Text text={MONEY(record?.net_discount?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_discount - b.net_discount,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'COGS',
      render: (text, record) => <H3Text text={MONEY(record?.net_cogs?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_cogs - b.net_cogs,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Net Margin',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <H3Text className={`${record.net_margin_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(record?.net_margin.toFixed(2)).split('.')[0]} />
          <span className={`table-subscript ${record.net_margin_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`}>
            {record.net_margin_percentage ? `${record.net_margin_percentage > 0 ? '+' : ''}${record.net_margin_percentage?.toFixed(2)}%` : '-'}
          </span>
        </div>
      ),
      sorter: (a, b) => a.net_margin_percentage - b.net_margin_percentage,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
  ];
  const salesPersonColumns = [
    {
      title: '',
      render: (record) => (
        <Link>
          <div className="mobile-list__item">
            <div style={{ display: 'flex' }}>
              <H3Text text={`${record?.sales_person_name}`} className="mobile-list__item-number" />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '5px',
                marginTop: '5px',
                flexDirection: 'column',
              }}
            >
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>Sales : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_sales?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>Discount : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_discount?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>COGS : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_cogs?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
            </div>
            <H3Text
              text={(
                <span className="mobile-list__item-info">
                  <span style={{ color: '#888888' }}>Net Margin : </span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <H3Text className={`${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(record?.net_margin.toFixed(2)).split('.')[0]} />
                    <span className={`table-subscript ${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`}>
                      {record.net_margin_percentage ? `(${record.net_margin_percentage > 0 ? '+' : ''}${record.net_margin_percentage?.toFixed(2)}%)` : '-'}
                    </span>
                  </div>
                </span>
              )}
            />
            {' '}
          </div>
        </Link>
      ),
      responsive: ['xs'],
    },
    {
      title: 'Sales Person',
      render: (text, record) => (
        <Tooltip title={record?.sales_person_name} className="">
          <a>
            <div>{record?.sales_person_name?.trim()?.length > 15 ? `${record?.sales_person_name.trim()?.substring(0, 15)}..` : record?.sales_person_name}</div>
          </a>
        </Tooltip>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Sales',
      render: (text, record) => <H3Text text={MONEY(record?.net_sales?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_sales - b.net_sales,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Discount',
      render: (text, record) => <H3Text text={MONEY(record?.net_discount?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_discount - b.net_discount,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'COGS',
      render: (text, record) => <H3Text text={MONEY(record?.net_cogs?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_cogs - b.net_cogs,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Net Margin',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <H3Text className={`${record.net_margin_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(record?.net_margin.toFixed(2)).split('.')[0]} />
          <span className={`table-subscript ${record.net_margin_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`}>
            {record.net_margin_percentage ? `${record.net_margin_percentage > 0 ? '+' : ''}${record.net_margin_percentage?.toFixed(2)}%` : '-'}
          </span>
        </div>
      ),
      sorter: (a, b) => a.net_margin_percentage - b.net_margin_percentage,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
  ];
  const sourceColumns = [
    {
      title: '',
      render: (record) => (
        <Link>
          <div className="mobile-list__item">
            <div style={{ display: 'flex' }}>
              <H3Text text={`${record?.source}`} className="mobile-list__item-number" />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '5px',
                marginTop: '5px',
                flexDirection: 'column',
              }}
            >
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>Sales : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_sales?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>Discount : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_discount?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
              <H3Text
                text={(
                  <span className="mobile-list__item-info">
                    <div style={{ color: '#888888' }}>COGS : </div>
                    <span style={{ color: '#3f74e3' }}>
                      {MONEY(record?.net_cogs?.toFixed(2)).split('.')[0]}
                    </span>
                  </span>
                )}
              />
            </div>
            <H3Text
              text={(
                <span className="mobile-list__item-info">
                  <span style={{ color: '#888888' }}>Net Margin : </span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <H3Text className={`${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(record?.net_margin.toFixed(2)).split('.')[0]} />
                    <span className={`table-subscript ${record.net_margin_percentage < 0 || !record.net_margin_percentage ? 'table-subscript-red' : 'table-subscript-green'}`}>
                      {record.net_margin_percentage ? `(${record.net_margin_percentage > 0 ? '+' : ''}${record.net_margin_percentage?.toFixed(2)}%)` : '-'}
                    </span>
                  </div>
                </span>
              )}
            />
            {' '}
          </div>
        </Link>
      ),
      responsive: ['xs'],
    },
    {
      title: 'Source',
      render: (text, record) => (
        <Tooltip title={`${record?.source}`} className="">
          <a>
            <div>{record?.source?.trim()?.length > 15 ? `${record?.source.trim()?.substring(0, 15)}..` : record?.source}</div>
          </a>
        </Tooltip>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Sales',
      render: (text, record) => <H3Text text={MONEY(record?.net_sales?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_sales - b.net_sales,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Discount',
      render: (text, record) => <H3Text text={MONEY(record?.net_discount?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_discount - b.net_discount,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'COGS',
      render: (text, record) => <H3Text text={MONEY(record?.net_cogs?.toFixed(2)).split('.')[0]} className="" />,
      sorter: (a, b) => a.net_cogs - b.net_cogs,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Net Margin',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <H3Text className={`${record.net_margin_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(record?.net_margin.toFixed(2)).split('.')[0]} />
          <span className={`table-subscript ${record.net_margin_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`}>
            {record.net_margin_percentage ? `${record.net_margin_percentage > 0 ? '+' : ''}${record.net_margin_percentage?.toFixed(2)}%` : '-'}
          </span>
        </div>
      ),
      sorter: (a, b) => a.net_margin_percentage - b.net_margin_percentage,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
  ];
  const customerGrowthColumns = [
    {
      title: '',
      render: (record) => (
        <Link to={`/sales/customer/view/${record.customer_id}`}>
          <div className="mobile-list__item">
            <div style={{ display: 'flex' }}>
              <H3Text text={`${record?.customer_name}`} className="mobile-list__item-number" />
            </div>
            <H3Text
              text={(
                <span className="mobile-list__item-info">
                  <span style={{ color: '#888888' }}>Previous Sales : </span>
                  <span style={{ color: '#3f74e3' }}>
                    {MONEY(Number(record?.previous_sales)?.toFixed(2)).split('.')[0]}
                    {' '}
                  </span>
                </span>
              )}
            />
            <H3Text
              text={(
                <span className="mobile-list__item-info">
                  <span style={{ color: '#888888' }}>Current Sales : </span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <H3Text className={`${record.growth_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(Number(record?.current_sales)?.toFixed(2)).split('.')[0]} />
                    <span className={`table-subscript ${record.growth_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`}>
                      {`(${record.growth_percentage > 0 ? '+' : ''}${Number(record.growth_percentage)?.toFixed(2)}%)`}
                    </span>
                  </div>
                </span>
              )}
            />
            {' '}
          </div>
        </Link>
      ),
      responsive: ['xs'],
    },
    {
      title: 'Customer',
      render: (text, record) => (
        <Tooltip title={record?.customer_name} className="">
          <a target="_blank" href={`/sales/customer/view/${record?.customer_id}`} rel="noreferrer">
            <div>{record?.customer_name?.trim()?.length > 15 ? `${record?.customer_name.trim()?.substring(0, 15)}..` : record?.customer_name}</div>
          </a>
        </Tooltip>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Previous Sales',
      render: (text, record) => <H3Text text={MONEY(Number(record?.previous_sales)?.toFixed(2)).split('.')[0]} className="" />,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Current Sales',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <H3Text className={`${record.growth_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`} text={MONEY(Number(record?.current_sales)?.toFixed(2)).split('.')[0]} />
          <span className={`table-subscript ${record.growth_percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`}>
            {`${record.growth_percentage > 0 ? '+' : ''}${Number(record.growth_percentage)?.toFixed(2)}%`}
          </span>
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
  ];

  function convertTableToCSV(headers, data) {
    const header = headers;
    const rows = data;
    const csv = [header, ...rows].map((row) => row.join(',')).join('\n');
    return csv;
  }

  function downloadCSV(csvContent, fileName) {
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);

    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  const handleDownloadCustomers = (dataSource) => {
    const headers = ['Customer Name', 'Net Sales', 'Net Discount', 'COGS', 'Net Margin', 'Margin(%)'];
    const data = dataSource.map((d) => {
      const customerData = [];
      customerData.push(`"${d.customer_name}"`);
      customerData.push((d.net_sales || 0)?.toFixed(2));
      customerData.push((d.net_discount || 0)?.toFixed(2));
      customerData.push((d.net_cogs || 0)?.toFixed(2));
      customerData.push((d.net_margin || 0)?.toFixed(2));
      customerData.push((d.net_margin_percentage || 0)?.toFixed(2));
      return customerData;
    });
    const csvContent = convertTableToCSV(headers, data);
    downloadCSV(csvContent, 'order_by_customer.csv');
  };
  const handleDownloadSource = (dataSource) => {
    const headers = ['Source', 'Net Sales', 'Net Discount', 'COGS', 'Net Margin', 'Margin(%)'];
    const data = dataSource.map((d) => {
      const sourceData = [];
      sourceData.push(`"${d.source}"`);
      sourceData.push((d.net_sales || 0)?.toFixed(2));
      sourceData.push((d.net_discount || 0)?.toFixed(2));
      sourceData.push((d.net_cogs || 0)?.toFixed(2));
      sourceData.push((d.net_margin || 0)?.toFixed(2));
      sourceData.push((d.net_margin_percentage || 0)?.toFixed(2));
      return sourceData;
    });
    const csvContent = convertTableToCSV(headers, data);
    downloadCSV(csvContent, 'order_by_source.csv');
  };

  const handleDownloadSalesPerson = (dataSource) => {
    const headers = ['Sales Person', 'Net Sales', 'Net Discount', 'COGS', 'Net Margin', 'Margin(%)'];
    const data = dataSource.map((d) => {
      const salesPersonData = [];
      salesPersonData.push(`"${d.sales_person_name}"`);
      salesPersonData.push((d.net_sales || 0)?.toFixed(2));
      salesPersonData.push((d.net_discount || 0)?.toFixed(2));
      salesPersonData.push((d.net_cogs || 0)?.toFixed(2));
      salesPersonData.push((d.net_margin || 0)?.toFixed(2));
      salesPersonData.push((d.net_margin_percentage || 0)?.toFixed(2));
      return salesPersonData;
    });
    const csvContent = convertTableToCSV(headers, data);
    downloadCSV(csvContent, 'order_by_sales_person.csv');
  };

  const handleDownloadProducts = (dataSource) => {
    const headers = ['Product Name', 'Units', 'Net Sales', 'Net Discount', 'COGS', 'Net Margin', 'Margin(%)'];
    const data = dataSource.map((d) => {
      const customerData = [];
      customerData.push(`"${d.product_sku_name}"`);
      customerData.push((d.total_units || 0)?.toFixed(2));
      customerData.push((d.net_sales || 0)?.toFixed(2));
      customerData.push((d.net_discount || 0)?.toFixed(2));
      customerData.push((d.net_cogs || 0)?.toFixed(2));
      customerData.push((d.net_margin || 0)?.toFixed(2));
      customerData.push((d.net_margin_percentage || 0)?.toFixed(2));
      return customerData;
    });
    const csvContent = convertTableToCSV(headers, data);
    downloadCSV(csvContent, 'order_by_product.csv');
  };
  const handleDownloadCustomerGrowth = (dataSource) => {
    const headers = ['Customer', 'Previous Sales', 'Current Sales', 'Growth(%)'];
    const data = dataSource?.map((d) => {
      const customerGrowthData = [];
      customerGrowthData.push(`"${d.customer_name}"`);
      customerGrowthData.push((parseFloat(d.previous_sales)?.toFixed(2) || 0));
      customerGrowthData.push((parseFloat(d.current_sales) || 0)?.toFixed(2));
      customerGrowthData.push((parseFloat(d.growth_percentage) || 0)?.toFixed(2));
      return customerGrowthData;
    });
    const csvContent = convertTableToCSV(headers, data);
    downloadCSV(csvContent, `customer_growth_${interval}.csv`);
  };

  const getPaymentReceivableData = () => {
    const data = analytics?.SALES?.ORDER_RECEIVABLES?.data;
    const totalCount = 0;
    const totalValue = Number(data?.total_receivables);
    const currentValue = Number(data?.receivables_today);
    return {
      overdueCount: 0,
      overdueValue: totalValue - currentValue,
      overdueColor: 'rgb(245,210,47)',
      currentCount: 0,
      currentValue,
      currentColor: 'rgb(34, 197, 94)',
      count: totalCount,
      value: totalValue,
      overdueList: {
        '1-15_days': {
          count: 0,
          amount: Number(data?.receivables_1_15_days),
          fromDate: dayjs().subtract(14, 'day').format('YYYY-MM-DD'),
          toDate: dayjs().format('YYYY-MM-DD'),
        },
        '16-30_days': {
          count: Number(data?.receivables_15_30_days),
          amount: Number(data?.receivables_15_30_days),
          fromDate: dayjs().subtract(29, 'day').format('YYYY-MM-DD'),
          toDate: dayjs().subtract(15, 'day').format('YYYY-MM-DD'),
        },
        '31-45_days': {
          count: Number(data?.receivables_30_45_days),
          amount: Number(data?.receivables_30_45_days),
          fromDate: dayjs().subtract(44, 'day').format('YYYY-MM-DD'),
          toDate: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
        },
        above_45_days: {
          count: Number(data?.receivables_45_days_above),
          amount: Number(data?.receivables_45_days_above),
          fromDate: dayjs().subtract(100, 'year').format('YYYY-MM-DD'),
          toDate: dayjs().subtract(45, 'day').format('YYYY-MM-DD'),
        },
      },
      entity: 'Total Receivable',
      entity_name_title: 'Pending Payments',
    };
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'source',
        filter_value: Helpers.getValueFromUrl('source') ? Helpers.getValueFromUrl('source')?.split(',') : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'accountManager',
        filter_value: Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
          identity: parseInt(item) == 0 ? 'UA' : orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'customer',
        filter_value: Helpers.getValueFromUrl('customer') ? Helpers.getValueFromUrl('customer')?.split(',').map(Number) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'taxType',
        filter_value: Helpers.getValueFromUrl('taxType') || 'EXCLUSIVE_OF_TAX',
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'tenant',
      filter_value: Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ),
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'startDate',
      filter_value: dateRangePresetsValues(dateRangePresets.THIS_MONTH)[0],
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: dateRangePresets.THIS_MONTH,
    },
    {
      filter_key: 'endDate',
      filter_value: dateRangePresetsValues(dateRangePresets.THIS_MONTH)[1],
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: dateRangePresets.THIS_MONTH,
    },
    {
      filter_key: 'source',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'accountManager',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'customer',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'taxType',
      filter_value: 'EXCLUSIVE_OF_TAX',
      filter_type: filterTypeEnums.STRING,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.SALES_DASHBOARD,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  const pushParamsToUrl = (tenant, start, end, source, accountManager, selectedCustomer, taxType, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '?tab=/sales-dashboard&';
    if (tenant) url += `tenant=${tenant}`;
    if (start) url += `&startDate=${start}`;
    if (end) url += `&endDate=${end}`;
    if (source) url += `&source=${source.join(',')}`;
    if (accountManager) url += `&accountManager=${accountManager?.map((item) => (item?.userId))?.join(',')}`;
    if (selectedCustomer) url += `&customer=${selectedCustomer?.join(',')}`;
    if (taxType) url += `&taxType=${taxType}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
        // setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
        //   userId: parseInt(item),
        //   title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
        //   identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        // })) : []);
      });
      getCustomers('', user?.tenant_info?.tenant_id, 1, 50, null, () => { }, '');
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setStartDate(Number(Helpers.getValueFromUrl('startDate')) || dayjs().utc().startOf('month').valueOf());
      // setEndDate(Number(Helpers.getValueFromUrl('endDate')) || dayjs().utc().endOf('month').subtract(1, 'day')
        // .valueOf());
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ));
      // setIsUserReady(true);
      // setType('CATEGORY');
      // setTaxType(Helpers.getValueFromUrl('taxType') || 'EXCLUSIVE_OF_TAX');
      setSelectedFilterView(systemDefaultUserView);
    }
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setSelectedTenant(tempFilterValues.tenant);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSource(tempFilterValues.source);
        setSelectedAssignee(tempFilterValues.accountManager);
        setSelectedCustomer(tempFilterValues.customer);
        setTaxType(tempFilterValues.taxType);
        setType('CATEGORY');
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  /**
   *
   */
  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(selectedTenant, startDate, endDate, source, selectedAssignee, selectedCustomer, taxType, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());

      getAnalyticsData('SALES', 'AVERAGE_ORDER_VALUE', {
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'ORDER_STATISTICS', {
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'ON_TIME_DELIVERY', {
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
      });
      getAnalyticsData('SALES', 'ORDER_COUNT_BY_STATUS', {
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
      });
      getAnalyticsData('SALES', 'ORDER_TREND', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'ORDER_VALUE_BY_CATEGORY', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        source: Helpers.getValueFromUrl('source'),
        type: 'CATEGORY',
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        taxType: Helpers.getValueFromUrl('taxType'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'ORDER_VALUE_BY_STATE', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        source: Helpers.getValueFromUrl('source'),
        type: 'STATE',
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'ORDER_STATS_BY_CUSTOMER', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'ORDER_STATS_BY_PRODUCT', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'ORDER_STATS_BY_SOURCE', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'ORDER_STATS_BY_SALES_PERSON', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'SALES_GROWTH_CUSTOMER_WISE', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        source: Helpers.getValueFromUrl('source'),
        interval,
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        isInclusiveOfTax: Helpers.getValueFromUrl('taxType') === 'INCLUSIVE_OF_TAX',
      });
      getAnalyticsData('SALES', 'ORDER_RECEIVABLES', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        source: Helpers.getValueFromUrl('source'),
        customerIds: Helpers.getValueFromUrl('customer'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
      });
    }
  }, [call, isUserReady, selectedFilterView]);

  useEffect(() => {
    getAnalyticsData('SALES', 'SALES_GROWTH_CUSTOMER_WISE', {
      startDate: dayjs(startDate).format('YYYY-MM-DD'),
      endDate: dayjs(endDate).format('YYYY-MM-DD'),
      tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
      source: Helpers.getValueFromUrl('source'),
      interval,
    });
  }, [interval]);

  const customSourceOptions = [{
    key: 'SALES_ORDER',
    label: documentUINames.salesOrderUIName,
  }, {
    key: 'DELIVERY_CHALLAN',
    label: 'Delivery Challan',
  }, {
    key: 'MANUFACTURING_ORDER',
    label: 'Manufacturing Order',
  }, {
    key: 'ADHOC',
    label: 'ADHOC',
  }, {
    key: 'SHOPIFY',
    label: 'Shopify',
  }, {
    key: 'UNICOMMERCE',
    label: 'Unicommerce',
  }];

  const intervalOptions = [
    {
      key: 'DAILY',
      label: 'Daily',
    },
    {
      key: 'WEEKLY',
      label: 'Weekly',
    },
    {
      key: 'MONTHLY',
      label: 'Monthly',
    },
  ];

  // useEffect(() => {
  //   getAnalyticsData('SALES', 'ORDER_VALUE_BY_TYPE', {
  //     startDate: dayjs(startDate).format('YYYY-MM-DD'),
  //     endDate: dayjs(endDate).format('YYYY-MM-DD'),
  //     type,
  //     tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
  //   });
  // }, [type]);
  const filtersPanel = (
    <div>
      <TenantSelector
        selectedTenant={selectedTenant}
        showSearch
        showAll={false}
        noDropdownAlign
        isMultiple
        onChange={(value) => {
          setSelectedTenant(value);
          setFirstTimeFilterDisable(true);
        }}
        placeholder="Select Business Unit"
        inputClassName="orgInputContainer"
        hideTitle
        includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)}
      />

      <H3DateSelector
        selectedInterval={orderDateSelectedIntervalDateRangeType}
        startDate={startDate}
        endDate={endDate}
        // onDateChange={(date) => {
        //   setFirstTimeFilterDisable(true);
        //   const getFormattedDate = (d) => dayjs(new Date(d).toISOString()?.split('T')?.[0]);
        //   setStartDate(date[0]?.valueOf());
        //   setEndDate(date[1]?.valueOf());
        //   setSelectedInterval('customize');
        //   pushParamsToUrl(
        //     selectedTenant,
        //     getFormattedDate(date[0])?.valueOf(),
        //     getFormattedDate(date[1])?.valueOf(),
        //   );
        // }}
        onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
          setFirstTimeFilterDisable(true);
          setStartDate(dayjs(date[0])?.startOf('day').valueOf());
          setEndDate(dayjs(date[1])?.endOf('day').valueOf());
          setCurrentPage(1);
          setOrderDateSelectedIntervalDateRangeType(dateRangeType);
        }}
      />
      <div className="custom-source-selector">
        <PRZSelect
          value={source}
          onChange={(value) => {
            setSource(value);
            setFirstTimeFilterDisable(true);
          }}
          placeholder="Select Source"
          mode="multiple"
          maxTagCount="responsive"
          style={{
            marginBottom: '15px',
          }}
          options={customSourceOptions}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <SelectCustomer
          hideTitle
          tenantId={user?.tenant_info?.tenant_id}
          isMultiple
          hideCity
          maxTagCount={1}
          noDropdownAlign
          onChange={(customers) => {
            setSelectedCustomer(customers);
            setFirstTimeFilterDisable(true);
          }}
          bordered
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <SelectUser
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          selectedUsers={selectedAssignee}
          maxTagCount="responsive"
          onSelect={(userId) => {
            setFirstTimeFilterDisable(true);
            setCurrentPage(1)
            setSelectedAssignee([
              ...selectedAssignee,
              {
                userId,
                title:
                  userId === 0
                    ? 'Unassigned'
                    : `${orgUsers?.data?.find(
                      (item) => item?.user_id === userId,
                    )?.first_name}`?.trim(),
                identity:
                  userId === 0
                    ? 'UA'
                    : orgUsers?.data
                      ?.find((item) => item?.user_id === userId)
                      ?.first_name?.substring(0, 2)
                      .toUpperCase(),
              },
            ]);
          }}
          onRemove={(userId) => {
            setSelectedAssignee([
              ...selectedAssignee?.filter((item) => item?.userId !== userId),
            ]);
          }}
          disabled={
            user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings
              ?.restrict_orders_of_other_acc_manager
          }
        />
      </div>
      <div className="apply_filter_wrapper">
        <Button
          type="primary"
          onClick={handleApplyFilters}
          disabled={!filterChanged}
          block
        >
          Apply Filters
        </Button>
      </div>
    </div>
  );

  return (
    <Fragment>
      <div
        className="filters-wrapper_mobile-view"
      >
        <div className="dashboard-filters doc-list__wrapper doc-list__tab-content">
          <div style={{
            marginRight: '10px',
          }}
          >
            <UserSavedFilterViewSelector
              selectedFilterView={selectedFilterView}
              onChangeTab={(currentSelectedView) => {
                setSelectedFilterView(() => {
                  const currentSelectedViewFilters = currentSelectedView.filters;

                  const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                  const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                  let _orderStartDate = '';
                  let _orderEndDate = '';

                  if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                    // No action needed for empty or custom date range type
                  } else {
                    const date = dateRangePresetsValues(_orderDateRangeType);
                    const [start, end] = date;

                    _orderStartDate = start;
                    _orderEndDate = end;
                    filterValue.startDate = _orderStartDate;
                    filterValue.endDate = _orderEndDate;
                  }

                  filterValue.orderDateRangeType = _orderDateRangeType;

                  const tempFilterValues = filterValue;
                  setCurrentPage(1);
                  setSelectedTenant(tempFilterValues.tenant);
                  setStartDate(tempFilterValues.startDate);
                  setEndDate(tempFilterValues.endDate);
                  setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                  setSource(tempFilterValues.source);
                  setSelectedAssignee(tempFilterValues.accountManager);
                  setSelectedCustomer(tempFilterValues.customer);
                  setTaxType(tempFilterValues.taxType);
                  setType('CATEGORY');

                  return currentSelectedView;
                });
              }}
              currentlyAppliedFilters={currentlyAppliedFilters}
              entityName={entityNameEnum.SALES_DASHBOARD}
              setSavedFilterViews={(value) => setSavedFilterViews(value)}
              setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
              setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
              callback={() => {
                if (!isUserReadyInitial) setIsUserReadyInitial(true);
              }}
              systemDefaultUserView={systemDefaultUserView}
            />
          </div>
          <TenantSelector
            selectedTenant={selectedTenant}
            showSearch
            showAll={false}
            noDropdownAlign
            isMultiple
            onChange={(value) => {
              setSelectedTenant(value);
              setFirstTimeFilterDisable(true);
            }}
            placeholder="Select Business Unit"
            inputClassName="orgInputContainer"
            hideTitle
            includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)}
          />
          <H3DateSelector
            selectedInterval={orderDateSelectedIntervalDateRangeType}
            startDate={startDate}
            endDate={endDate}
            // onDateChange={(date) => {
            //   setFirstTimeFilterDisable(true);
            //   const getFormattedDate = (d) => (dayjs(new Date(d).toISOString()?.split('T')?.[0]));
            //   setStartDate(date[0]?.valueOf());
            //   setEndDate(date[1]?.valueOf());
            //   setSelectedInterval('customize');
            //   pushParamsToUrl(selectedTenant, getFormattedDate(date[0])?.valueOf(), getFormattedDate(date[1])?.valueOf());
            // }}
            onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
              setFirstTimeFilterDisable(true);
              setStartDate(dayjs(date[0])?.startOf('day').valueOf());
              setEndDate(dayjs(date[1])?.endOf('day').valueOf());
              setCurrentPage(1);
              setOrderDateSelectedIntervalDateRangeType(dateRangeType);
            }}
          />
          {/* <div className="custom-source-selector">
            <Select
              value={source}
              onChange={(value) => {
                setSource(value);
                setFirstTimeFilterDisable(true);
              }}
              placeholder="Select Source"
              mode="multiple"
              maxTagCount="responsive"
            >
              <Option key="SALES_ORDER" value="SALES_ORDER">{documentUINames.salesOrderUIName}</Option>
              <Option key="DELIVERY_CHALLAN" value="DELIVERY_CHALLAN"> Delivery Challan</Option>
              <Option key="MANUFACTURING_ORDER" value="MANUFACTURING_ORDER"> Manufacturing Order</Option>
              <Option key="ADHOC" value="ADHOC">ADHOC</Option>
              <Option key="SHOPIFY" value="SHOPIFY">Shopify</Option>
              <Option key="UNICOMMERCE" value="UNICOMMERCE">Unicommerce</Option>
            </Select>
          </div> */}
          <PRZSelect
            value={source}
            onChange={(value) => {
              setSource(value);
              setFirstTimeFilterDisable(true);
            }}
            placeholder="Select Source"
            mode="multiple"
            maxTagCount="responsive"
            wrapperClassName="custom-source-selector"
          >
            <Option key="SALES_ORDER" value="SALES_ORDER">{documentUINames.salesOrderUIName}</Option>
            <Option key="DELIVERY_CHALLAN" value="DELIVERY_CHALLAN">Delivery Challan</Option>
            <Option key="MANUFACTURING_ORDER" value="MANUFACTURING_ORDER">Manufacturing Order</Option>
            <Option key="ADHOC" value="ADHOC">ADHOC</Option>
            <Option key="SHOPIFY" value="SHOPIFY">Shopify</Option>
            <Option key="UNICOMMERCE" value="UNICOMMERCE">Unicommerce</Option>
          </PRZSelect>
          <SelectCustomer
            hideTitle
            tenantId={user?.tenant_info?.tenant_id}
            isMultiple
            hideCity
            maxTagCount={1}
            noDropdownAlign
            onChange={(customers) => {
              setSelectedCustomer(customers);
              setFirstTimeFilterDisable(true);
            }}
            bordered
          />
          <div style={{ marginLeft: '20px' }}>
            {/* <Select
              value={taxType}
              onChange={(value) => {
                setTaxType(value);
                setFirstTimeFilterDisable(true);
              }}
              placeholder="Select Tax Type"
              maxTagCount="responsive"
            >
              <Option key="INCLUSIVE_OF_TAX" value="INCLUSIVE_OF_TAX">Inclusive of Tax</Option>
              <Option key="EXCLUSIVE_OF_TAX" value="EXCLUSIVE_OF_TAX">Exclusive of Tax</Option>
            </Select> */}
            <PRZSelect
              value={taxType}
              onChange={(value) => {
                setTaxType(value);
                setFirstTimeFilterDisable(true);
              }}
              placeholder="Select Tax Type"
              maxTagCount="responsive"
              options={[
                { value: 'INCLUSIVE_OF_TAX', label: 'Inclusive of Tax' },
                { value: 'EXCLUSIVE_OF_TAX', label: 'Exclusive of Tax' },
              ]}
            />
          </div>
          <div style={{ marginLeft: '20px' }}>
            <SelectUser
              selectedUsers={selectedAssignee}
              maxTagCount="responsive"
              onSelect={(userId) => {
                setFirstTimeFilterDisable(true);
                setSelectedAssignee([...selectedAssignee, {
                  userId,
                  title: userId === 0 ? 'Unassigned' : `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                  identity: userId === 0 ? 'UA' : orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                }]);
              }}
              onRemove={(userId) => {
                setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
              }}
              disabled={user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.restrict_orders_of_other_acc_manager}
            />
          </div>
          &nbsp;&nbsp;
          <div
            className="apply_filter_wrapper"
          >
            <Button
              type="primary"
              onClick={handleApplyFilters}
              disabled={!filterChanged}
            >
              Apply Filters
            </Button>
          </div>

        </div>

        <Button type="primary" onClick={showDrawer} className="mobile-view-filter-button">
          Filters
        </Button>
      </div>
      <Drawer
        open={isDrawerVisible}
        width="320px"
        mask
        onClose={closeDrawer}
        destroyOnClose
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '270px' }}>
            <H3Text text="Apply Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={closeDrawer} />
          </div>
        </div>
        {filtersPanel}
      </Drawer>
      <div className="ant-row sales_dashboard__wrapper sales_dashboard__wrapper_mobile_view" style={{ marginTop: '20px', width: 'calc(100% + 10px)' }}>
        <div className="ant-col-md-4">
          <MetricView data={analytics.SALES.AVERAGE_ORDER_VALUE.data} loading={analytics.SALES.AVERAGE_ORDER_VALUE.loading} value={parseInt(analytics.SALES.AVERAGE_ORDER_VALUE.data?.average_order_value || 0)} title="Average Order Value" type="AMOUNT" />
        </div>
        <div className="ant-col-md-4">
          <MetricView data={analytics.SALES.AVERAGE_ORDER_VALUE.data} loading={analytics.SALES.ORDER_STATISTICS.loading} value={parseInt(analytics.SALES.ORDER_STATISTICS.data?.net_sales || 0)} title="Net Sales" type="AMOUNT" />
        </div>
        <div className="ant-col-md-4">
          <MetricView data={analytics.SALES.AVERAGE_ORDER_VALUE.data} loading={analytics.SALES.ORDER_STATISTICS.loading} value={parseInt(analytics.SALES.ORDER_STATISTICS.data?.net_discount || 0)} title="Net Discount" type="AMOUNT" />
        </div>
        <div className="ant-col-md-4">
          <MetricView data={analytics.SALES.AVERAGE_ORDER_VALUE.data} loading={analytics.SALES.ORDER_STATISTICS.loading} value={parseInt(analytics.SALES.ORDER_STATISTICS.data?.net_cogs || 0)} title="Cost of Goods Sold" type="AMOUNT" />
        </div>
        <div className="ant-col-md-4">
          <MetricView data={analytics.SALES.AVERAGE_ORDER_VALUE.data} loading={analytics.SALES.ORDER_STATISTICS.loading} value={parseInt(analytics.SALES.ORDER_STATISTICS.data?.net_margin || 0)} percentage={parseFloat(analytics.SALES.ORDER_STATISTICS.data?.net_margin_percentage || 0)?.toFixed(2)} title="Margin" type="AMOUNT" />
        </div>
        <div className="ant-col-md-4">
          <MetricView data={analytics.SALES.AVERAGE_ORDER_VALUE.data} loading={analytics.SALES.ON_TIME_DELIVERY.loading} value={parseFloat(analytics.SALES.ON_TIME_DELIVERY.data?.on_time_delivery_percentage || 0)?.toFixed(2)} title="On Time Delivery (%)" type="PERCENTAGE" />
        </div>
      </div>
      <div className="ant-row sales_dashboard__wrapper" style={{ marginTop: '10px', width: 'calc(100% + 10px)' }}>
        <div className="ant-col-md-8 full-width_mobile_view">
          <MetricWithAmountSplit data={getPaymentReceivableData()} loading={analytics?.PURCHASE?.OVERDUE_GRN?.loading} selectedTenant={selectedTenant} hideOverDueListPopover showOverdueList />
        </div>
        <div className="ant-col-md-16 full-width_mobile_view" style={{ width: 'calc(66.64% - 10px)', marginRight: '10px' }}>
          <MetricBarLineChart data={analytics.SALES.ORDER_TREND.data || []} loading={analytics.SALES.ORDER_TREND.loading} title="Order Fulfillment Day-Wise Trend" />
        </div>
      </div>
      <div className="ant-row sales_dashboard__wrapper" style={{ marginTop: '10px', width: 'calc(100% + 10px)' }}>
        <div className="ant-col-md-12 highest-value-customers_wrapper_mobile-view">
          <div className="sales-dashboard-table__wrapper">
            <div className="sales-dashboard-table__title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <H3Text text="Highest Value Customers" />
              <div className="sales-dashboard-table__action-btn">
                <H3Text
                  text={(
                    <FontAwesomeIcon icon={faDownload} onClick={() => handleDownloadCustomers(analytics.SALES.ORDER_STATS_BY_CUSTOMER.data)} color="rgb(0,143,251)" style={{ cursor: 'pointer' }} />
                  )}
                />
              </div>
            </div>
            <div className="sales-dashboard-table__content">
              <div className="sales-dashboard-table__chart">
                <Table
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={customerColumns}
                  dataSource={analytics.SALES.ORDER_STATS_BY_CUSTOMER.data}
                  loading={analytics.SALES.ORDER_STATS_BY_CUSTOMER.loading}
                  pagination={
                    {
                      pageSize: 5,
                      showSizeChanger: false,
                    }
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="ant-col-md-12 highest-selling-products_wrapper_mobile-view">
          <div className="sales-dashboard-table__wrapper">
            <div className="sales-dashboard-table__title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <H3Text text="Highest Selling Products" className="sales-dashboard-table__title" />
              <div className="sales-dashboard-table__action-btn">
                <H3Text
                  text={(
                    <FontAwesomeIcon icon={faDownload} onClick={() => handleDownloadProducts(analytics.SALES.ORDER_STATS_BY_PRODUCT.data)} color="rgb(0,143,251)" style={{ cursor: 'pointer' }} />
                  )}
                />
              </div>
            </div>
            <div className="sales-dashboard-table__content">
              <div className="sales-dashboard-table__chart">
                <Table
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={productColumns}
                  dataSource={analytics.SALES.ORDER_STATS_BY_PRODUCT.data}
                  loading={analytics.SALES.ORDER_STATS_BY_PRODUCT.loading}
                  pagination={{
                    pageSize: 5,
                    showSizeChanger: false,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ant-row sales_dashboard__wrapper" style={{ marginTop: '10px', width: 'calc(100% + 10px)' }}>
        <div className="ant-col-md-12 sales-by-sales-person_wrapper_mobile-view">
          <div className="sales-dashboard-table__wrapper">
            <div className="sales-dashboard-table__title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <H3Text text="Sales by Sales Person" />
              <div className="sales-dashboard-table__action-btn">
                <H3Text
                  text={(
                    <FontAwesomeIcon icon={faDownload} onClick={() => handleDownloadSalesPerson(analytics.SALES.ORDER_STATS_BY_SALES_PERSON.data)} color="rgb(0,143,251)" style={{ cursor: 'pointer' }} />
                  )}
                />
              </div>
            </div>
            <div className="sales-dashboard-table__content">
              <div className="sales-dashboard-table__chart">
                <Table
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={salesPersonColumns}
                  dataSource={analytics.SALES.ORDER_STATS_BY_SALES_PERSON.data}
                  loading={analytics.SALES.ORDER_STATS_BY_SALES_PERSON.loading}
                  pagination={
                    {
                      pageSize: 5,
                      showSizeChanger: false,
                    }
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="ant-col-md-12 customer-growth_wrapper_mobile-view">
          <div className="sales-dashboard-table__wrapper">
            <div className="sales-dashboard-table__title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <H3Text text="Customers at Risk" />
              <div style={{ display: 'flex' }}>
                <div className="sales-dashboard-table__action-btn__interval">
                  <PRZSelect
                    value={interval}
                    onChange={(value) => {
                      setInterval(value);
                    }}
                    placeholder="Select Interval"
                    options={intervalOptions}
                  />
                </div>
                <div className="sales-dashboard-table__action-btn">
                  <H3Text
                    text={(
                      <FontAwesomeIcon icon={faDownload} onClick={() => handleDownloadCustomerGrowth(analytics.SALES.SALES_GROWTH_CUSTOMER_WISE.data)} color="rgb(0,143,251)" style={{ cursor: 'pointer' }} />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="sales-dashboard-table__content">
              <div className="sales-dashboard-table__chart">
                <Table
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={customerGrowthColumns}
                  dataSource={analytics.SALES.SALES_GROWTH_CUSTOMER_WISE.data}
                  loading={analytics.SALES.SALES_GROWTH_CUSTOMER_WISE.loading}
                  pagination={
                    {
                      pageSize: 5,
                      showSizeChanger: false,
                    }
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ant-row sales_dashboard__wrapper" style={{ marginTop: '10px', width: 'calc(100% + 10px)' }}>
        <div className="ant-col-md-12 sales-overview-by-source_wrapper_mobile-view">
          <div className="sales-dashboard-table__wrapper">
            <div className="sales-dashboard-table__title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <H3Text text="Sales Overview by Source" className="sales-dashboard-table__title" />
              <div className="sales-dashboard-table__action-btn">
                <H3Text
                  text={(
                    <FontAwesomeIcon icon={faDownload} onClick={() => handleDownloadSource(analytics.SALES.ORDER_STATS_BY_SOURCE.data)} color="rgb(0,143,251)" style={{ cursor: 'pointer' }} />
                  )}
                />
              </div>
            </div>
            <div className="sales-dashboard-table__content">
              <div className="sales-dashboard-table__chart">
                <Table
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={sourceColumns}
                  dataSource={analytics.SALES.ORDER_STATS_BY_SOURCE.data}
                  loading={analytics.SALES.ORDER_STATS_BY_SOURCE.loading}
                  pagination={{
                    pageSize: 5,
                    showSizeChanger: false,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="ant-col-md-12 metric-sales-pie-chart_wrapper_mobile-view">
          <MetricSalesPieChart data={analytics.SALES.ORDER_VALUE_BY_CATEGORY.data || []} loading={analytics.SALES.ORDER_VALUE_BY_CATEGORY.loading} type="CATEGORY" title="Fulfilled Orders By Category" />
        </div>
      </div>
      <div className="ant-row sales_dashboard__wrapper " style={{ marginTop: '10px', width: 'calc(100% + 10px)', marginBottom: '20px' }}>
        <div className="ant-col-md-12 metric-sales-pie-chart_wrapper_mobile-view">
          <MetricSalesPieChart data={analytics.SALES.ORDER_VALUE_BY_STATE.data || []} loading={analytics.SALES.ORDER_VALUE_BY_STATE.loading} type="STATE" title="Fulfilled Orders By State" />
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, AnalyticsReducers, TenantReducers, CustomerReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  analytics: AnalyticsReducers.analytics,
  orgUsers: TenantReducers.orgUsers,
  customers: CustomerReducers.customers,
});

const mapDispatchToProps = (dispatch) => ({
  getAnalyticsData: (dataType, name, params) => dispatch(AnalyticsActions.getAnalyticsData(dataType, name, params)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
  getCustomers: (keyword, tenantId, page, limit, customerId, callback, accManagerIds, selectedCustomerIds) => dispatch(
    CustomerActions.getCustomers(keyword, tenantId, page, limit, customerId, callback, accManagerIds, selectedCustomerIds),
  ),
});

SalesDashboard.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  analytics: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SalesDashboard));
